const NotificationIconInHeader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect opacity="0.2" width="40" height="40" rx="8" fill="white" />
      <path
        d="M18.1461 11.2479C18.2956 10.8786 18.5519 10.5624 18.8822 10.3397C19.2125 10.117 19.6018 9.99805 20.0001 9.99805C20.3985 9.99805 20.7878 10.117 21.1181 10.3397C21.4484 10.5624 21.7047 10.8786 21.8541 11.2479C23.3329 11.6546 24.6373 12.5355 25.5669 13.7553C26.4966 14.975 27.0001 16.4663 27.0002 17.9999V22.6969L28.8322 25.4449C28.9326 25.5955 28.9903 25.7706 28.9991 25.9514C29.0079 26.1322 28.9674 26.3121 28.882 26.4717C28.7966 26.6313 28.6695 26.7648 28.5142 26.8578C28.3588 26.9508 28.1812 27 28.0002 26.9999H23.4651C23.3447 27.833 22.9282 28.5949 22.2919 29.1459C21.6555 29.6969 20.8419 30.0001 20.0001 30.0001C19.1584 30.0001 18.3448 29.6969 17.7084 29.1459C17.0721 28.5949 16.6556 27.833 16.5351 26.9999H12.0001C11.8191 27 11.6415 26.9508 11.4861 26.8578C11.3308 26.7648 11.2037 26.6313 11.1183 26.4717C11.0329 26.3121 10.9924 26.1322 11.0012 25.9514C11.01 25.7706 11.0677 25.5955 11.1681 25.4449L13.0001 22.6969V17.9999C13.0001 14.7759 15.1801 12.0599 18.1461 11.2479ZM18.5862 26.9999C18.6894 27.2926 18.8809 27.546 19.1343 27.7252C19.3876 27.9045 19.6903 28.0007 20.0006 28.0007C20.311 28.0007 20.6137 27.9045 20.867 27.7252C21.1204 27.546 21.3119 27.2926 21.4151 26.9999H18.5851H18.5862ZM20.0001 12.9999C18.6741 12.9999 17.4023 13.5267 16.4646 14.4644C15.5269 15.4021 15.0001 16.6738 15.0001 17.9999V22.9999C15.0002 23.1975 14.9417 23.3906 14.8321 23.5549L13.8691 24.9999H26.1301L25.1671 23.5549C25.0579 23.3905 24.9998 23.1974 25.0001 22.9999V17.9999C25.0001 16.6738 24.4734 15.4021 23.5357 14.4644C22.598 13.5267 21.3262 12.9999 20.0001 12.9999Z"
        fill="white"
      />
      <circle
        cx="25"
        cy="14"
        r="3.375"
        fill="#E62D38"
        stroke="#F3F5F9"
        strokeWidth="1.25"
      />
    </svg>
  );
};
export default NotificationIconInHeader;
